module.exports = __webpack_public_path__ + "img/pr-11.84415de5.png";